<div class="container simulation-manager">
    <div class="row">
        <div class="col-md-12">
            <h6 class="section-heading">Start Simulation(s)</h6>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-7 col-md-12">
            <form autocomplete="off" id="txtSimulationForm" [formGroup]="customerSearchForm">
                <div class="row row-bottom-space">
                    <div class="col-md-4">

                        <app-alight-smart-search-drop-down [group]="customerSearchForm" [controlName]="'SIM_clientName'"
                            [required]="true" (changeEvent)="onClientChange($event)" (clearEvent)="onClearSelection($event)"
                            description="clientName" [clearSeleAvailable]="!rootService.disableDropdown()"
                            [disable]="rootService.disableDropdown()" label="Client" [value]="'clientName'"
                            [list]=" customerService.clients">
                    </app-alight-smart-search-drop-down>
                    </div>

                    <div class="col-md-4">
                        <app-alight-drop-down [group]="customerSearchForm" [controlName]="'simulationType'"
                            [required]="true" value="fieldValue" description="fieldValueDescription"
                            label="Simulation Type" (changeEvent)="onSimulationChange($event)"
                            [list]="simulationTypeValueFilter()"></app-alight-drop-down>
                    </div>
                    <!-- CCR3-12199 Enable to show Authentication Method dropdown -->
                    <div class="col-md-4" >
                        <app-alight-drop-down [group]="customerSearchForm" [controlName]="'authModels'" [required]="customerSearchForm.get('simulationType')?.value !== 'Secured - Web Message'"
                            value="authModels" description="authModels" label="Authentication Method" [disable]="customerSearchForm.get('simulationType')?.value === 'Secured - Web Message'"
                            [list]="rootService.LOB_methods" ></app-alight-drop-down>
                    </div>
                </div>
                <div class="row row-bottom-space">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName" appAutoCompleteOff id="lastName"
                                (focus)="onFocus($event)" />
                            <mat-error *ngIf="
                                          
                                          errorHandling('lastName', 'pattern')
                                        ">
                                <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                                {{ errorMsg.lastName }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName" id="firstName" appAutoCompleteOff
                                (focus)="onFocus($event)" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label>Phone Number</mat-label>
                            <input matInput formControlName="phoneNumber" id="phoneNumber" inputmode="numeric" maxlength="15"
                                (focus)="onFocus($event)" (keyup)="onKeyUp($event, 'phoneNumber')"/>
                            <mat-error *ngIf=" !customerSearchForm.get('phoneNumber')?.hasError('invalidSpecialChar') &&
                                      (errorHandling('phoneNumber', 'minlength')) && !(errorHandling('phoneNumber', 'pattern'))">
                                <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                                {{errorMsg.phoneNumberLen}}
                            </mat-error>
                            <mat-error
                                *ngIf="errorHandling('phoneNumber', 'pattern') && !customerSearchForm.get('phoneNumber')?.hasError('invalidSpecialChar')">
                                {{errorMsg.charactersValidation}}
                            </mat-error>
                            <mat-error *ngIf="customerSearchForm.get('phoneNumber')?.hasError('invalidSpecialChar')">
                                {{errorMsg.specialCharacter}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-bottom-space">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>Employee ID</mat-label>
                            <input matInput formControlName="employeeId" appAutoCompleteOff id="employeeId" (focus)="onFocus($event)" (keyup)="onKeyUp($event, 'employeeId')"/>
                            <mat-error *ngIf="customerSearchForm.get('employeeId')?.hasError('invalidSpecialChar')">
                                {{errorMsg.specialCharacter}}
                            </mat-error>
                            <mat-error *ngIf=" !customerSearchForm.get('employeeId')?.hasError('invalidSpecialChar') && (errorHandling('employeeId', 'minlength')) && !(errorHandling('employeeId', 'pattern'))">
                                <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> 
                                {{errorMsg.employeeIdLen}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>National ID (Last 4)</mat-label>
                            <input matInput formControlName="nationalId" id="nationalId" maxlength="4"
                                appAutoCompleteOff />
                            <mat-error *ngIf="
                                            errorHandling('nationalId', 'minlength') ||
                                            errorHandling('nationalId', 'pattern')
                                          ">
                                <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                                {{ errorMsg.nationalId }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box cp-datepicker">
                            <mat-label>Date of Birth (MMM-DD-YYYY)</mat-label>
                            <input matInput appAutoCompleteOff [matDatepicker]="picker1" [max]="maxDate"
                                formControlName="dateOfBirth" (focus)="onFocus($event)">
                            <mat-datepicker-toggle (click)="onFocus($event)" matIconSuffix
                                [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-error *ngIf="customerSearchForm.get('dateOfBirth')?.hasError('matDatepickerParse')">
                                <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                                Invalid date format: {{
                                customerSearchForm.get('dateOfBirth')?.getError('matDatepickerParse').text }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    
                </div>

                <div class="row">
                    
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>Postal Code</mat-label>
                            <input matInput formControlName="postalCode" id="postalCode" appAutoCompleteOff
                                (focus)="onFocus($event)" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-button-controls">
                            <f-button text="Clear all" title="Clear all" type="button" variant="action"
                                (buttonClicked)="clearAll()"></f-button>
                            <f-button text="Search" title="Search" type="submit" variant="progressive" uuid="txtSearch"
                                [disabled]="checkSearchDisable()" (buttonClicked)="onSubmit()">
                            </f-button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-5 col-md-12 simulation-card">
            <f-data-card>
                <div class="simulation-controls flex justify-space-between">
                    <h6> Active Simulation(s) </h6>
                    <a class="end-btn hide" href="#">End all simulations</a>
                </div>
                <section class="error-wrapper hide">
                    <f-alert variant="error">
                        <p> There was a problem loading the data. <button class="btn-alert">Try again</button></p>
                    </f-alert>
                </section>
                <div class="no-result" *ngIf="rootService.simulationRecords.length === 0">
                    <p>There are no active simulations.</p>
                </div>
        
        
                <div class="form simulation-row " *ngIf="rootService.simulationRecords.length >0">
                    <div class=" simulation-data row-header" >
                        <div class="">
                            <span class="form-label"> Customer Account </span>
        
                        </div>
                        <div class="">
                            <span class="form-label"> Simulation Type </span>
        
                        </div>
                        <div class="">
                            <span class="form-label"> Action </span>
        
                        </div>
                    </div>
        
                    <ng-container *ngFor="let simRecord of rootService.simulationRecords; let i = index">
                        <div class="simulation-data" >
                            <div class="customer-info">
        
                                <span class="form-value"> {{simRecord.fullName | titlecase}} </span>
                            </div>
                            <div class="simulation-type">
        
                                <span class="form-value">
                                    <f-icon *ngIf="simRecord.channel === Constants.conversion.call"
                                        icon-config='{"iconName": "phone", "iconType": "solid", "iconSize": "s"}'
                                        [ngClass]="getSecurityLevelClass(simRecord)" class="simulation-icon"></f-icon>
                                    <f-icon *ngIf="simRecord.channel === Constants.conversion.chat"
                                        icon-config='{"iconName": "comment", "iconType": "solid", "iconSize": "s"}'
                                        class="green simulation-icon"></f-icon>
                                        {{simRecord.channel | titlecase}}
                                </span>
                            </div>
                            <div class="simulation-actions">
        
                                <span class="form-value"> <f-button text="End Simulation" title="End Simulation" type="button"
                                        variant="action" (buttonClicked)="simulationService.endSimulation(simRecord.conversationId)"></f-button>
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </div>
        
        
            </f-data-card>
        </div>
    </div>



    <div class="row">
        <div class="col-md-4">
            <h6 class="search-result">Search Results</h6>
        </div>
        <div class="col-md-8">
            <h6 class="display-result" *ngIf="totalRecords > 0 && totalRecords <= 50">

                Displaying
                <strong>{{ alightTable?.totalCount }}</strong> records
            </h6>
        </div>
    </div>

    <app-alight-table [dataSource]="dataSource" [totalRecords]="totalRecords" [gridColumns]="Columns" [rowPerPage]="10"
        tableName="simulationTable" (rowSelection)="rowSelection($event)" [GoToCustomerAcc]="false"
        [disableButtons]="rootService.isDuplicateCustSearchTabOpened" [hideReplaceAddButton]="true"></app-alight-table>

    <div class="footer-controls">
        <div class="footer-controls-left">
            <f-button text="Start Simulation" [disabled]="disableStartSimBtn()" title="Start Simulation" type="button"
                variant="progressive" (click)="startSimulation()">
            </f-button>
        </div>
    </div>
    <app-loader *ngIf="rootService.custSearchLoader" [loaderType]="loaderType"
        [loaderMsg]="rootService.showCustSearchLoaderMsg"></app-loader>
</div>